import { contextualizeEventDefinitionModuleV2 } from './context-v2.js';
export function createEventModule(eventDefinition) {
    return contextualizeEventDefinitionModuleV2(eventDefinition);
}
